import styled from 'styled-components';

export const Page = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 140px);
  padding: 24px;
`;

export const Card = styled.div`
  background: rgba(255, 255, 255, 0.84);
  border: 1px solid rgba(30, 79, 121, 0.18);
  backdrop-filter: blur(12px);
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 16px 30px rgba(15, 42, 66, 0.12);
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Brand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
`;

export const BrandName = styled.span`
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #1e4f79;
  text-transform: uppercase;
`;

export const Title = styled.h1`
  margin: 0 0 8px 0;
  font-size: 22px;
  color: #163a59;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #c8d4df;
  outline: none;
  background: rgba(255, 255, 255, 0.82);
  &:focus { border-color: #1e4f79; }
`;

export const InputWrapper = styled.div`
  position: relative;
  input {
    padding-right: 110px;
  }
`;

export const PasswordToggle = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #1e4f79;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
`;

export const Row = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  color: #222B82;
  text-decoration: underline;
`;

export const ErrorText = styled.div`
  color: #ca2d61;
  font-size: 14px;
`;
